<template>
  <div>
    <DialogBaseText
      class="text-center primary--text mt-4"
      v-html="$t('component.profile.accountManagement.register.info')">
    </DialogBaseText>
    <v-divider></v-divider>
    <DialogBaseActions>
      <v-row class="ma-0">
        <v-col>
          <v-btn
            id="identityFormRegisterCancel"
            class="text-center px-8"
            color="secondary"
            dark
            depressed
            @click.stop="handleCancel"
            >{{ $t('button.cancel') }}</v-btn>
        </v-col>
        <v-col>
          <v-btn
            id="identityFormRegisterSubmit"
            class="text-center px-8"
            color="primary"
            dark
            depressed
            :loading="loading"
            @click="$emit('register')">
            {{ $t('button.register') }}</v-btn>
        </v-col>
      </v-row>
    </DialogBaseActions>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters(['locale'])
  },
  methods: {
    async handleCancel() {
      await this.$router.push({
        name: 'login',
        params: { locale: this.locale }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
